import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($state, $scope, $stateParams, $filter, InsuranceSuiteMetadata) {
    // , ReinstatementService, UserInfoService) => {
    var ctrl = Object.create(BaseCtrl);

    $scope.reinstatementNumber = $stateParams.reinstatementNumber;
    console.log('reinstatementSummaryCtrl reinstatementNumber=' + $scope.reinstatementNumber + ', reinstatement:');
    console.log($scope.reinstatement);
    $scope.unfilteredActivities = [];
    /**
    * Function to populate Scope object with messages
    * @params{Object} - reinstatement
    * @returns{Object} - Updates $scope variable with values returned from the passed in object.
    * @private
    **/
    ctrl.translateMessages = function (reinstatement) {
        var status = reinstatementStatus(reinstatement);
        console.log('status', status);
        $scope.canWithdraw = status !== 'Bound' && status !== 'Withdrawn';
        $scope.reinstatementInfoMessageTitle = getInfoMessageTitle(status);
        $scope.reinstatementInfoMessage1 = getInfoMessage1(status);
        $scope.reinstatementInfoMessage2 = getInfoMessage2(status);
    };
    /**
    * Function to return messages
    * @params{String} - status
    * @returns{String | null}
    * @private
    **/
    function getInfoMessageTitle(status) {
        if (status === 'Started') {
            return null;
        } else if (status === 'Submitted') {
            return $filter('translate')('policy.common.reinstatement-detail.The reinstatement request has been submitted');
        } else if (status === 'Quoted') {
            return $filter('translate')('policy.common.reinstatement-detail.The reinstatement request has been submitted');
        } else if (status === 'Withdrawn') {
            return $filter('translate')('policy.common.reinstatement-detail.The reinstatement request has been withdrawn');
        } else if (status === 'Bound') {
            return $filter('translate')('policy.common.reinstatement-detail.The policy has been reinstated');
        } else return null;
    }
    /**
     * Function to return messages
     * @params{String} - status
     * @returns{String | null}
     * @private
     **/
    function getInfoMessage1(status) {
        //DEF1506-SIT cycle 2-Regression-Reinstatement submit message is irrelevant 
        if (status === 'Started') {
            return $filter('translate')('policy.common.reinstatement-detail.To continue with your reinstatement, click on Submit reinstatement.');
        } else if (status === 'Submitted') {
            return $filter('translate')('policy.common.reinstatement-detail.You will receive a notification from Montana State Fund once your order is processed.');
        } else if (status === 'Quoted') {
            return $filter('translate')('policy.common.reinstatement-detail.You will receive a notification from Montana State Fund once your order is processed.');
        } else if (status === 'Withdrawn') {
            return $filter('translate')('policy.common.reinstatement-detail.If you need to reinstate the policy please create a new reinstatement');
        } else if (status === 'Bound') {
            return null;
        } else return null;
    }
    /**
     * Function to return messages
     * @params{String} - status
     * @returns{String | null}
     * @private
     **/
    function getInfoMessage2(status) {
        if (status === 'Started') {
            return $filter('translate')('policy.common.reinstatement-detail.In order to withdraw reinstatement, click on Withdraw reinstatement.');
        } else return null;
    }
    /**
     * Function to return reinstatement status
     * @params{Object} - reinstatement
     * @returns{String | null}
     * @private
     **/
    function reinstatementStatus(reinstatement) {
        if (reinstatement.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Draft').name) {
            if (reinstatement.approvalActivity) {
                return 'Submitted';
            } else return 'Started';
        } else return reinstatement.status;
    }

    $scope.$watch('reinstatement', function () {
        // When we navigate between quote detail tiles, ui-router instantiates controllers
        // with _new_ prototypically-inherited $scope. When we update reinstatement on that scope from within,
        // it does not gets updated on a parent (because of prototypical inheritance).
        // Then when we navigate between states again the change is lost.
        // This propagates the change to the parent state.
        $scope.$parent.reinstatement = $scope.reinstatement;
        if (angular.isDefined($scope.reinstatement)) {
            ctrl.translateMessages($scope.reinstatement);
        }
    });

    return ctrl.create($scope);
};
fn.$inject = ['$state', '$scope', '$stateParams', '$filter', 'InsuranceSuiteMetadata']; //, 'ReinstatementService', 'UserInfoService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/ReinstatementSummaryCtrl.js
// module id = 1685
// module chunks = 0